import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { SERVICES } from "@/data/services";
import { scrollTo } from "@/components/site/Header";

// Bento spans — asymmetric layout
const SPANS = [
  "md:col-span-2 md:row-span-2", // tyre (big)
  "md:col-span-1 md:row-span-1", // battery
  "md:col-span-1 md:row-span-1", // servicing
  "md:col-span-1 md:row-span-2", // towing (tall)
  "md:col-span-1 md:row-span-1", // insurance
];

const ServiceCard = ({ s, span, big, index }) => (
  <motion.button
    data-testid={`service-card-${s.id}`}
    onClick={() => scrollTo("request")}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className={`group relative overflow-hidden bg-rescue-surface border border-white/10 text-left min-h-[220px] ${span}`}
  >
    <img
      src={s.image}
      alt={s.label}
      className="absolute inset-0 h-full w-full object-cover opacity-45 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/10" />
    <div className="relative z-10 h-full flex flex-col justify-between p-6">
      <div className="flex items-start justify-between">
        <span className="font-display text-white/40 text-xl">/{s.tag}</span>
        <span className="grid place-items-center h-9 w-9 border border-white/20 rounded-sm text-white group-hover:bg-rescue-primary group-hover:border-rescue-primary transition-colors">
          <ArrowUpRight weight="bold" size={18} />
        </span>
      </div>
      <div>
        <h3 className={`font-display uppercase tracking-tight text-white leading-none ${big ? "text-5xl sm:text-6xl" : "text-3xl"}`}>
          {s.label}
        </h3>
        <p className={`text-white/65 mt-3 leading-relaxed ${big ? "max-w-md text-base" : "text-sm"}`}>
          {s.blurb}
        </p>
      </div>
    </div>
  </motion.button>
);

export const Services = () => {
  return (
    <section id="services" className="relative bg-rescue-bg py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="text-rescue-primary font-semibold uppercase tracking-[0.3em] text-xs">
              What we handle
            </span>
            <h2 className="font-display uppercase tracking-tighter text-white text-6xl sm:text-7xl lg:text-8xl leading-[0.85] mt-4">
              Every<br />breakdown.
            </h2>
          </div>
          <p className="max-w-sm text-white/60 text-base leading-relaxed">
            Six core rescue lines, one dispatch team. Tap any service to send a request — we route
            the nearest verified technician to your exact location.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 auto-rows-[220px] gap-4">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.id} s={s} span={SPANS[i]} big={i === 0} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
